import { useLayout } from '@approvalmax/ui/src/components';
import { ExpandedCompany } from 'modules/common/selectors/types';
import { hooks as pageHooks } from 'modules/page';
import { hocs as pageHocs } from 'modules/page/hocs';
import { memo } from 'react';
import { useParams } from 'react-router-dom';

import { pageConfig } from './config';
import { Loading } from './loading';
import { NetSuiteCustomFields } from './resources/components';
import { useBreadcrumbs } from './resources/hooks/useBreadcrumbs';
import { usePageData } from './resources/hooks/usePageData';

const Content = memo((props: { company: ExpandedCompany | null }) => {
    const { company } = props;

    useBreadcrumbs();

    const { customFieldReference, customFieldList, isLoading } = usePageData(company?.id);

    return isLoading || !company || !customFieldReference || !customFieldList ? (
        <Loading />
    ) : (
        <NetSuiteCustomFields
            company={company}
            customFieldReference={customFieldReference}
            customFieldList={customFieldList}
        />
    );
});

export const Page = memo(() => {
    useLayout({ hasHeader: true, hasDrawer: true });

    const { companyId } = useParams<{ companyId: string }>();
    const { company } = pageHooks.useNonExistentCompanyError(companyId);

    return <Content company={company} />;
});

export default pageHocs.withProtected({
    Page: Page,
    roles: pageConfig.access,
    integrationTypes: pageConfig.integrationTypes,
});
